import React from "react";
import Modal from '../Modal'
import LoaderButton from "../LoaderButton";
import { translate } from "../../utils/useful";
import FormViewer from "../FormViewer";
import SwitchInput from "../inputs/SwitchInput";
import TopicView from "../views/messenger/sideBar/TopicView";
import StagesManager from "../StagesManager";
import ImportModalFirst from "./ImportModalFirst";
import ImportModalSecond from "./ImportModalSecond";
import ImportModalThird from "./ImportModalThird";
import ImportModalForth from "./ImportModalForth";


class BatchUpdate extends React.Component {
    state = {
        headers: [
            { key: 'table', type: 'SelectInput', col: '6', information: { type: "local", items: [{ title: 'Table 1', value: 'Equal' }, { title: 'Table 2', value: 'Equal' }], label: '{{lang}}Table', placeholder: 'Pick a table...', required: false } },
            { key: 'layout', type: 'SelectInput', col: '6', information: { type: "local", items: [{ title: 'A4 (210mm x 297mm)', value: 'Equal' }], label: '{{lang}}View', placeholder: '{{lang}}Pick a view...', required: false } },
            // { key: 'fieldsizing', type: 'SelectInput', col: '6', information: { type: "local", items: [{ title: 'A4 (210mm x 297mm)', value: 'Equal' }, { title: 'Less Than', value: 'Equal' }], label: '{{lang}}Feild sizing', placeholder: '{{lang}}Actual size', required: true } },
            // { key: 'fontsize', type: 'SelectInput', col: '6', information: { type: "local", items: [{ title: 'A4 (210mm x 297mm)', value: 'Equal' }, { title: 'Less Than', value: 'Equal' }], label: '{{lang}}Font size', placeholder: '{{lang}}Normal', required: true } },
        ],

        headers2: [
            { key: 'field', type: 'SelectInput', col: '6', information: { type: "local", items: [{ title: 'Name', value: 'Equal' }, { title: 'Assignee', value: 'Equal' }, { title: 'Notes', value: 'Equal' }, { title: 'Status', value: 'Equal' }], label: '{{lang}}Feild', placeholder: 'Pick a field to update...', required: false } },
            { key: 'action', type: 'SelectInput', col: '6', information: { type: "local", items: [{ title: 'Clear cell contents', value: 'Equal' }, { title: 'Set cell value', value: 'Equal' }, { title: 'set cell value randomly', value: 'Equal' }], label: '{{lang}}Action', placeholder: '{{lang}}Pick an action', required: false } },
            { key: 'value', type: 'TextInput', col: '12', information: { label: '{{lang}}New Value', placeholder: '{{lang}}Select...', required: true } },
            // { key: 'fontsize', type: 'SelectInput', col: '6', information: { type: "local", items: [{ title: 'A4 (210mm x 297mm)', value: 'Equal' }, { title: 'Less Than', value: 'Equal' }], label: '{{lang}}Font size', placeholder: '{{lang}}Normal', required: true } },
        ],
    }


    render() {
        let options = this.state.options
        return (


            <div className="">
                <div className="p-3 flexcb" style={{backgroundColor:"#fff", borderBottom:"1px solid #eee"}}>
                    <p className="font-size-14 weight-300">Batch Update</p>
                    <button className="blue-btn br-5 px-2 py-1" onClick={() => this.props.changeStage("confirm")}>
                        <p className="white">Update</p>
                    </button>
                </div>
                <div className="mt-2">
                    <FormViewer ref={el => this.form = el} headers={this.state.headers} theme={"modern"} inputClass={"modern-input"} />
                </div>
                <div>
                    <div className="px-3">
                        <p className="font-size-14 weight-300">Actions</p>
                    </div>
                    <div className="mt-3 py-2 mx-2 br-10" style={{border:"1px solid #eee"}}>
                        <FormViewer ref={el => this.form = el} headers={this.state.headers2} theme={"modern"} inputClass={"modern-input"} />
                    </div>
                </div>
                <div className="p-2">
                    <button className="flexc"> 
                        <img width={24} src="/assets/icons/plus-blue.svg"/>
                        <p style={{color:"#0961ed"}}>Add action</p>
                    </button>
                </div>
            </div>

        );

    }
}


export default BatchUpdate;
